var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconReturn({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_18074",
    "data-name": "Grupo 18074",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.832,
    height: 22.22,
    viewBox: "0 0 20.832 22.22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_284",
    "data-name": "Trazado 284",
    d: "M5.5,8.194A.694.694,0,0,1,6.194,7.5h5.555a.694.694,0,1,1,0,1.389H6.194A.694.694,0,0,1,5.5,8.194Z",
    transform: "translate(2.138 2.916)",
    fill: "#003082",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_285",
    "data-name": "Trazado 285",
    d: "M3.778,0H17.665a2.778,2.778,0,0,1,2.778,2.778V19.443a2.778,2.778,0,0,1-2.778,2.778H3.778A2.778,2.778,0,0,1,1,19.443V18.054H2.389v1.389a1.389,1.389,0,0,0,1.389,1.389H17.665a1.389,1.389,0,0,0,1.389-1.389V2.778a1.389,1.389,0,0,0-1.389-1.389H3.778A1.389,1.389,0,0,0,2.389,2.778V4.166H1V2.778A2.778,2.778,0,0,1,3.778,0Z",
    transform: "translate(0.389)",
    fill: "#003082"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_286",
    "data-name": "Trazado 286",
    d: "M1.389,5.389V4.694a.694.694,0,1,1,1.389,0v.694h.694a.694.694,0,1,1,0,1.389H.694a.694.694,0,1,1,0-1.389Zm0,8.333v-.694a.694.694,0,1,1,1.389,0v.694h.694a.694.694,0,1,1,0,1.389H.694a.694.694,0,1,1,0-1.389Z",
    transform: "translate(0 1.555)",
    fill: "#003082"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2308",
    "data-name": "Trazado 2308",
    d: "M1.36,19.717v-.68a.68.68,0,0,1,1.36,0v.68H3.4a.68.68,0,1,1,0,1.36H.68a.68.68,0,1,1,0-1.36Z",
    transform: "translate(0.043 -8.607)",
    fill: "#003082"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReturn);
export default __webpack_public_path__ + "static/media/icon_return.a4ceeba7458752ae6ecde0fd714651e7.svg";
export { ForwardRef as ReactComponent };